"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _header = require("./header");

var _Head = _interopRequireDefault(require("./Head"));

var _Row = _interopRequireDefault(require("./Row"));

var _virtualized = _interopRequireDefault(require("./virtualized/virtualized.table"));

var _data = require("./data");

var _ExpandableRow = _interopRequireDefault(require("./expandable/ExpandableRow"));

var _DraggableRow = _interopRequireDefault(require("./draggable/DraggableRow"));

var _ExpandedRowData = _interopRequireDefault(require("./expandable/ExpandedRowData"));

var _Body = _interopRequireDefault(require("./Body"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Table =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Table, _React$PureComponent);

  function Table() {
    _classCallCheck(this, Table);

    return _possibleConstructorReturn(this, _getPrototypeOf(Table).apply(this, arguments));
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          bordered = _this$props.bordered,
          borderless = _this$props.borderless,
          bubbleRows = _this$props.bubbleRows,
          fullWidth = _this$props.fullWidth,
          lightBubbleRows = _this$props.lightBubbleRows,
          selectable = _this$props.selectable,
          sortable = _this$props.sortable,
          striped = _this$props.striped,
          scrollable = _this$props.scrollable,
          scrollableHeight = _this$props.scrollableHeight,
          fontSmall = _this$props.fontSmall,
          draggable = _this$props.draggable,
          props = _objectWithoutProperties(_this$props, ["children", "bordered", "borderless", "bubbleRows", "fullWidth", "lightBubbleRows", "selectable", "sortable", "striped", "scrollable", "scrollableHeight", "fontSmall", "draggable"]);

      var _processChildren = (0, _utils.processChildren)(children, {
        scrollable: scrollable,
        scrollableHeight: scrollableHeight,
        draggable: draggable
      }),
          processedChildren = _processChildren.processedChildren,
          options = _processChildren.options;

      var hasExpandableRows = options.hasExpandableRows;
      var classes = ['co-table', _defineProperty({
        'co-table--bordered': bordered,
        'co-table--bubble-rows': bubbleRows,
        'co-table--expandable': hasExpandableRows,
        'co-table--bubble-rows co--light': lightBubbleRows,
        'co-table--selectable': selectable,
        'co-table--sortable': sortable,
        'co-table--draggable-rows': draggable,
        'co-table--striped': striped,
        'co-table--scrollable': scrollable || scrollableHeight
      }, "co-table--scrollable--".concat(scrollableHeight), scrollableHeight)];
      var allowedModifiers = {
        fontSmall: fontSmall,
        borderless: borderless,
        fullWidth: fullWidth
      };
      return _react.default.createElement(_styler.default, {
        classNames: classes,
        modifiers: allowedModifiers
      }, function (styles) {
        return _react.default.createElement("table", _extends({
          className: styles
        }, (0, _getNativeProps.default)(props)), processedChildren);
      });
    }
  }]);

  return Table;
}(_react.default.PureComponent);

var exclusiveRowVariations = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('bubbleRows', 'lightBubbleRows', 'bordered');
Table.propTypes = {
  /** {---} Sequence of: @@<Table.Head>@@ (optional, max: 1), @@<Table.Body>@@ (required, min: 1) */
  children: _propTypes.any.isRequired,
  bordered: _propTypes.bool,
  borderless: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@bubbleRows@@ @@lightBubbleRows@@ @@bordered@@ */
  bubbleRows: exclusiveRowVariations,
  fullWidth: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@bubbleRows@@ @@lightBubbleRows@@ @@bordered@@ */
  lightBubbleRows: exclusiveRowVariations,
  sortable: _propTypes.bool,
  selectable: _propTypes.bool,
  scrollable: _propTypes.bool,

  /** {number} Between 100 and 1000 in increments of 50; Incompatible with @@<Table.ExpandableRow>@@ */
  scrollableHeight: _utils.scrollableHeightProp,
  striped: _propTypes.bool,
  draggable: _propTypes.bool,
  fontSmall: _propTypes.bool
};
Table.Head = _Head.default;
Table.Header = _header.Header;
Table.ActionHeader = _header.ActionHeader;
Table.Body = _Body.default;
Table.Row = _Row.default;
Table.ExpandableRow = _ExpandableRow.default;
Table.DraggableRow = _DraggableRow.default;
Table.Data = _data.Data;
Table.ActionData = _data.ActionData;
Table.ExpandedRowData = _ExpandedRowData.default;
Table.Virtualized = _virtualized.default;
var _default = Table;
exports.default = _default;
Table.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@<Table.Head>@@ (optional, max: 1), @@<Table.Body>@@ (required, min: 1)"
    },
    "bordered": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "borderless": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "bubbleRows": {
      "type": {
        "name": "custom",
        "raw": "exclusiveRowVariations"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@bubbleRows@@ @@lightBubbleRows@@ @@bordered@@"
    },
    "fullWidth": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "lightBubbleRows": {
      "type": {
        "name": "custom",
        "raw": "exclusiveRowVariations"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@bubbleRows@@ @@lightBubbleRows@@ @@bordered@@"
    },
    "sortable": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "selectable": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "scrollable": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "scrollableHeight": {
      "type": {
        "name": "custom",
        "raw": "scrollableHeightProp"
      },
      "required": false,
      "description": "{number} Between 100 and 1000 in increments of 50; Incompatible with @@<Table.ExpandableRow>@@"
    },
    "striped": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "draggable": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "fontSmall": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};